import { store } from "global";
import { QueueMode } from "models/app/player/input";

export const isQueueViewDisabled = () => {
    const { queue } = store.getState();
    const isModeMixRadio = queue.mode === QueueMode.MixRadio;
    return isModeMixRadio;
};
